import {
  formatCurrency,
  CurrencyCode,
  transformDate,
  colors,
  Buttonlink,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { RoutePath } from '../../../../types/Routes'

// TODO: Remove the mess of inherited styles from ResultTable so we can use a normal table here
const Row = styled.div`
  display: flex;
  row-gap: 12px;
  flex-wrap: wrap;
  font-size: 0.9em;
`
const Unit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const Blob = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${colors.black};
  border-radius: 5px;
  padding: 2px 5px;
  text-align: center;
`
const Redeem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.green};
  border-radius: 5px;
  padding: 2px 5px;
  position: relative;
  div {
    position: absolute;
    top: -16px;
  }
  strong {
    color: ${colors.white};
  }
`
const ArrowContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`
const Line = styled.div`
  position: absolute;
  width: 100%;
  background-color: ${colors.darkGray};
  height: 1px;
`
const Arrow = styled(MdKeyboardArrowRight)`
  width: 20px;
  height: 20px;
  color: ${colors.darkGray};
`
type Props = {
  redemptionHistory: {
    id: number
    value: number
    redemptionValue: number
    redemptionDate: number
  }[]
  currencyCode?: CurrencyCode
}
export default function Timeline(props: Props): ReactElement {
  const { redemptionHistory, currencyCode } = props
  const history = useHistory()

  const goTo = (targetId: number | undefined): void => {
    if (targetId) {
      history.push(
        `${RoutePath.VoucherDetail}/${targetId}`,
        history.location.state, // Preserve the state (from sales table or home page)
      )
    }
  }

  const timeline = [...redemptionHistory].reverse()

  return (
    <Row>
      {timeline.map(({ id, value, redemptionValue, redemptionDate }, index) => {
        const was = currencyCode && formatCurrency(value, currencyCode)
        const redeemed = currencyCode && formatCurrency(redemptionValue, currencyCode)
        const date = transformDate(redemptionDate)

        return (
          <Unit key={id}>
            <Blob>
              <Buttonlink onClick={(): void => goTo(id)}>{id}</Buttonlink>
              <div>{was}</div>
            </Blob>
            <ArrowContainer>
              <Line />
              <Arrow />
            </ArrowContainer>
            {redeemed && (
              <Redeem>
                <div>{date}</div>
                <strong>{redeemed}</strong>
              </Redeem>
            )}
            <ArrowContainer>
              <Line />
              <Arrow />
            </ArrowContainer>
            {index + 1 === timeline.length && (
              <Blob style={{ width: 'min-content' }}>this voucher</Blob>
            )}
          </Unit>
        )
      })}
    </Row>
  )
}
